import { Button, ButtonGroup, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect, useContext } from "react";
import "./SideNavigationStyles.css";
import "../../styles/typography.css";
import { RoleContext } from "../../RoleContext"; // adjust path as needed

import hamberger from "../Assests/Icons/hamberger.png";
import Leftnav1 from "../Assests/Icons/Leftnav1.png";
import Leftnav2 from "../Assests/Icons/Leftnav2.png";
import Leftnav3 from "../Assests/Icons/Leftnav3.png";
import Leftnav4 from "../Assests/Icons/Leftnav4.png";
import Leftnav5 from "../Assests/Icons/Leftnav5.png";
import closeHam from "../Assests/Icons/Vector.png";

// field staff icons
import Leftnav6 from "../Assests/Icons/Leftnav6.png";

import Leftnav7 from "../Assests/Icons/add-sample-icon.png";


import AssayRequest from "../Assests/Icons/AssayRequest.png";
import Faq from "../Assests/Icons/Faq.png";
import NotificationBell from "../Assests/Icons/NotificationBell.png";
import Reports from "../Assests/Icons/Reports.png";
import RequestFeed from "../Assests/Icons/RequestFeed.png";
import Settings from "../Assests/Icons/Settings.png";
import { getCustomerRequests } from "../../pages/Support Management/SupportManagementApi";

// Map API role names to navigation items
const NAV_ITEMS_BY_ROLE = {
  "Lab Admin": [
    { icon: Leftnav1, label: "Global Dashboard", path: "/global-dashboard" },
    { icon: Leftnav2, label: "Admin Dashboard", path: "/admin-dashboard" },
    { icon: Leftnav3, label: "User Management", path: "/user-management" },
    {
      icon: Leftnav4,
      label: "Company Management",
      path: "/company-management",
    },
    {
      icon: Leftnav5,
      label: "Support Management",
      path: "/support-management",
    },
    {
      icon: Leftnav7,
      label: "Add sample",
      path: "/company-management",
      state: { tab: "Customer", openAddSample: true },
    },
  ],
  "IT Admin": [
    { icon: Leftnav1, label: "Global Dashboard", path: "/global-dashboard" },
    { icon: Leftnav2, label: "Admin Dashboard", path: "/admin-dashboard" },
    { icon: Leftnav3, label: "User Management", path: "/user-management" },
    {
      icon: Leftnav4,
      label: "Company Management",
      path: "/company-management",
    },
    {
      icon: Leftnav5,
      label: "Support Management",
      path: "/support-management",
    },
  ],
  Customer: [
    { icon: Leftnav2, label: "Dashboard", path: "/customer-dashboard" },
    {
      icon: RequestFeed,
      label: "Request Feed Assay",
      path: "/request-feed-assay",
    },
    {
      icon: AssayRequest,
      label: "Assay Request Record",
      path: "/assay-request-record",
    },
    { icon: Reports, label: "Reports", path: "/customer-reports" },
    { icon: NotificationBell, label: "Notification", path: "/notification" },
    { icon: Settings, label: "Settings", path: "/settings" },
    { icon: Faq, label: "FAQ", path: "/Faq" },
  ],
  Analyst: [
    { icon: Leftnav2, label: "Analyst Dashboard", path: "/analyst-dashboard" },
    {
      icon: Leftnav4,
      label: "Company Management",
      path: "/analyst-companyManagement",
    },
    {
      icon: Leftnav7,
      label: "Add sample",
      path: "/analyst-companyManagement",
      state: { tab: "Customer", openAddSample: true },
    },
  ],
  "Field Staff": [
    { icon: Leftnav2, label: "Dashboard", path: "/field-staff-dashboard" },
    {
      icon: Leftnav6,
      label: "Request List",
      path: "/field-staff-request-list",
    },
  ],
};

const SideNavigation = ({ expanded, setExpanded, navItems }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { role } = useContext(RoleContext);
  const [activeLabel, setActiveLabel] = useState(null);
  const [supportRequestCount, setSupportRequestCount] = useState(() => {
    const stored = Number(localStorage.getItem("supportRequestCount"));
    return Number.isNaN(stored) ? 0 : stored;
  });

  const sideNavItems = NAV_ITEMS_BY_ROLE[role] || [];

  const items = navItems || sideNavItems;

  // Clear activeLabel when navigating to a different path
  useEffect(() => {
    if (activeLabel) {
      const item = items.find((i) => i.label === activeLabel);
      if (item && item.path !== location.pathname) {
        setActiveLabel(null);
      }
    }
  }, [location.pathname]);

  useEffect(() => {
    const handleSupportCountUpdated = (event) => {
      const nextCount = Number(event?.detail?.count);
      setSupportRequestCount(Number.isNaN(nextCount) ? 0 : nextCount);
    };

    const handleStorage = (event) => {
      if (event.key !== "supportRequestCount") return;
      const nextCount = Number(event.newValue);
      setSupportRequestCount(Number.isNaN(nextCount) ? 0 : nextCount);
    };

    window.addEventListener("support-count-updated", handleSupportCountUpdated);
    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener("support-count-updated", handleSupportCountUpdated);
      window.removeEventListener("storage", handleStorage);
    };
  }, []);

  useEffect(() => {
    const hasSupportManagement = items.some(
      (item) => item.label === "Support Management"
    );
    if (!hasSupportManagement) return;

    let cancelled = false;

    const fetchSupportCount = async () => {
      try {
        const data = await getCustomerRequests(1, 1, "");
        const nextCount = Number(data?.totalRecords) || 0;
        if (cancelled) return;

        setSupportRequestCount(nextCount);
        localStorage.setItem("supportRequestCount", String(nextCount));
        window.dispatchEvent(
          new CustomEvent("support-count-updated", {
            detail: { count: nextCount },
          })
        );
      } catch (error) {
        if (cancelled) return;

        const stored = Number(localStorage.getItem("supportRequestCount"));
        setSupportRequestCount(Number.isNaN(stored) ? 0 : stored);
      }
    };

    fetchSupportCount();

    return () => {
      cancelled = true;
    };
  }, [items]);

  return (
    <div className={`side-nav ${expanded ? "expanded" : "collapsed"}`}>
      <ButtonGroup vertical className="w-100">
        {/* Hamburger Icon */}
        <Button
          className="side-nav-item hamburger-btn"
          onClick={() => setExpanded((prev) => !prev)}
          title={expanded ? "Collapse sidebar" : "Expand sidebar"}
        >
          <div className="side-icon">
            {expanded ? (
              <img src={closeHam} alt="Close Menu" className="hamburger-icon" />
            ) : (
              <img src={hamberger} alt="Menu" className="hamburger-icon" />
            )}
          </div>
        </Button>

        {/* Sidebar Items */}
        {items.map(({ icon, label, path, state }, index) => {
          // If user clicked a specific nav item sharing the same path, use activeLabel to disambiguate
          const hasDuplicatePath = items.filter((i) => i.path === path).length > 1;
          const isActive = hasDuplicatePath
            ? activeLabel === label
            : location.pathname === path;
          const showSupportBadge =
            label === "Support Management" && supportRequestCount > 0;

          const navButton = (
            <Button
              key={label}
              className={`side-nav-item ${isActive ? "active" : ""}`}
              onClick={() => {
                setActiveLabel(label);
                navigate(path, { state });
              }}
            >
              <div className="side-icon">
                <img src={icon} alt={label} />
                {showSupportBadge && (
                  <span className="side-badge">{supportRequestCount}</span>
                )}
              </div>
              {expanded && <span className="side-label">{label}</span>}
            </Button>
          );

          return expanded ? (
            <div key={index}>{navButton}</div>
          ) : (
            <OverlayTrigger
              key={index}
              placement="right"
              overlay={<Tooltip id={`tooltip-${label}`}>{label}</Tooltip>}
            >
              {navButton}
            </OverlayTrigger>
          );
        })}
      </ButtonGroup>
    </div>
  );
};

export default SideNavigation;
